import React, { useEffect } from 'react';
import AccountsDashboard from './Dashboard/AccountsDashboard';
import ContentEngagement from './ContentEngagement/ContentEngagement';
import AnalyticsAccounts from '../Accounts/AnalyticsAccounts';
import { TAB_ANALYTICS_INNER } from 'constants/paths';
import EmailEngagement from '../Contacts/ContactsInner/EmailEngagement/EmailEngagement';
import { resetAccountsEmailEngagement } from '../Contacts/ContactsInner/EmailEngagement/actions';
import { useSelector } from 'react-redux';
import { RootState } from 'store';

interface IAccountTabsRouting {
  tab?: string;
  page?: string;
  setSearchedText: (value: string) => void;
  searchedText: string;
}
const AccountTabsRouting: React.FC<IAccountTabsRouting> = ({ tab, page, searchedText, setSearchedText }) => {
  const engagementEmails = useSelector((state: RootState) => state.emailsEngagement.emails);

  useEffect(() => {
    if (engagementEmails.length) {
      resetAccountsEmailEngagement();
    }
  }, []);

  return (
    <>
      {tab === undefined ? (
        <AnalyticsAccounts setSearchedText={setSearchedText} searchedText={searchedText} />
      ) : tab === TAB_ANALYTICS_INNER.DASHBOARD ? (
        <AccountsDashboard setSearchedText={setSearchedText} searchedText={searchedText} />
      ) : tab === TAB_ANALYTICS_INNER.CONTENT ? (
        <ContentEngagement setSearchedText={setSearchedText} searchedText={searchedText} />
      ) : tab === TAB_ANALYTICS_INNER.EMAIL_ENGAGEMENT ? (
        <EmailEngagement page={page} tab={tab} />
      ) : null}
    </>
  );
};

export default AccountTabsRouting;
